import React, { useState } from 'react';
import { Box, Paper, TextField, Button, Typography, CircularProgress, Alert } from '@mui/material';
import AppsIcon from '@mui/icons-material/Apps';
import { useAuth } from '../../contexts/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try { await login(email, password); }
    catch { setError('Invalid email or password.'); }
    finally { setLoading(false); }
  };

  return (
    <Box sx={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'radial-gradient(ellipse at top, #1a1a2e 0%, #0d0d14 70%)', p: 2,
    }}>
      <Paper sx={{ p: 4, width: '100%', maxWidth: 380, bgcolor: 'rgba(26,26,46,0.95)', border: '1px solid rgba(92,107,192,0.25)' }}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Box sx={{ width: 60, height: 60, borderRadius: '50%', bgcolor: 'rgba(92,107,192,0.15)', border: '2px solid rgba(92,107,192,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 2 }}>
            <AppsIcon sx={{ color: 'primary.light', fontSize: 28 }} />
          </Box>
          <Typography variant="h5" fontWeight={700}>My Apps</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>Sign in to access your apps</Typography>
        </Box>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField label="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} required fullWidth />
          <TextField label="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} required fullWidth />
          <Button type="submit" variant="contained" size="large" disabled={loading} fullWidth>
            {loading ? <CircularProgress size={22} color="inherit" /> : 'Sign In'}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
